import React from "react";
import { Power } from "lucide-react";

/** Active/Disabled pill + toggle button. */
export default function DrawerStatusBar({ active, isSelf, saving, onToggle }) {
  return (
    <div
      className="px-5 py-3 border-b-2 flex items-center justify-between"
      style={{ borderBottomColor: "rgba(249,215,28,0.2)" }}
    >
      <span
        className={`inline-flex items-center gap-2 px-3 py-1 text-[11px] font-black uppercase tracking-wider border-2 ${
          active
            ? "bg-status-current text-white border-status-current"
            : "bg-status-expired text-white border-status-expired"
        }`}
      >
        <span className="w-2 h-2 bg-white" />
        {active ? "Active" : "Disabled"}
      </span>
      {!isSelf && (
        <button
          data-testid="toggle-active"
          onClick={onToggle}
          disabled={saving}
          className="text-xs font-bold uppercase tracking-wider inline-flex items-center gap-1.5 px-3 h-9 border-2 hover:bg-safety-yellow hover:text-black transition-colors disabled:opacity-50"
          style={{ borderColor: "#F9D71C" }}
        >
          <Power className="w-3.5 h-3.5" strokeWidth={3} />
          {active ? "Disable" : "Enable"}
        </button>
      )}
    </div>
  );
}
